var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.dashboardComponent,_vm._b({key:_vm.$store.state.national.mode,tag:"component"},'component',_vm.$props,false))
}
var staticRenderFns = []

export { render, staticRenderFns }